export class Window {
    static isCompact() {
        return window.innerWidth <= 800;
    }
}